export const registerLinkHelper = (alpine) => {
	alpine.directive('link', (el, {}, { cleanup }) => {
		const ta = $(el);
		ta.on('click', function (e) {
			const href = ta.attr('href');
			alpine.store('router').go(href);
			e.preventDefault();
		});

		cleanup(() => {
			ta.off('click');
		});
	});
};
